const routes = [
    {
        path: "/tyyc/basic/field/outcomes",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "tyycbasicfieldoutcome_index"
        }
    }
];

export default routes;